import { createRoot } from 'react-dom/client';
import { App } from './pages/App';
import 'react-toastify/dist/ReactToastify.css';
import './styles/index.css';

// if (import.meta.env.PROD) {
//     sentryInit();
// }

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
